module.exports = {
    "en": {
        "...": "...",
        "abc_down": "ABC name Down",
        "abc_up": "ABC name Up",
        "add": "Add",
        "api": "API",
        "api_settings": "API Settings",
        "add_painting": "Add painting",
        "add_storage": "Add storage",
        "address": "Address",
        "all": "All",
        "aluminum": "Aluminum",
        "at_work": "At Work",
        "available": "Available",
        "bots": "Bots",
        "cancel": "Cancel",
        "canvas": "Canvas",
        "clear": "Clear",
        "client_prospective": "Client prospective",
        "close": "Close",
        "contact": "Contact",
        "contact_description": "Contact description",
        "contact_info": "Contact info",
        "contact_send_success": "Contact send success",
        "contact_success": "Contact success",
        "contact_us": "Contact us",
        "create": "Create",
        "delete": "Delete",
        "display": "Display",
        "done": "Done",
        "drying": "Drying",
        "edit": "Edit",
        "export_your_data": "Export your data",
        "email": "Email",
        "exit_admin_perspective": "Exit admin perspective",
        "filters": "Filters",
        "gouache": "Gouache",
        "graphite": "Graphite",
        "id_down": "ID Down",
        "id_up": "ID Up",
        "ink": "Ink",
        "landscape": "Landscape",
        "main_image": "Main Image",
        "material": "Material",
        "message": "Message",
        "message_sent_successfully": "Your message has been sent successfully!",
        "name": "Name",
        "no": "No",
        "not_available": "Not Available",
        "notes": "Notes",
        "nu_painting_to_display": "Number of paintings to display",
        "oil": "Oil",
        "on": "On",
        "open_form": "Open form",
        "open_storage_panel": "Open storage panel",
        "orientation": "Orientation",
        "paintings": "Paintings",
        "paper": "Paper",
        "portrait": "Portrait",
        "price": "Price",
        "price_down": "Price Down",
        "price_up": "Price Up",
        "publish": "Publish",
        "refresh": "Refresh",
        "register": "Register",
        "reset": "Reset",
        "save": "Save",
        "search": "Search",
        "select": "Select",
        "send": "Send",
        "size": "Size",
        "sketches": "Sketches",
        "sort": "Sort",
        "sort_by": "Sort by",
        "stage": "Stage",
        "storage": "Storage",
        "target_date": "Dry & Ready for Next",
        "target_point": "Dry & Ready for Next",
        "new_storage": "New Storage",
        "edit_storage": "Edit Storage",
        // "target_point_up": "Target Point",
        "text": "Text",
        "thank_you_for_contacting": "Thank you for contacting us. We'll get back to you soon.",
        "type": "Type",
        "url_name": "URL Name",
        "url_name_warning": "Warning: if you change the URL name, all requests to the old URL will no longer be available.",
        "waiting_for_varnish": "Waiting for varnish",
        "watercolor": "Watercolor",
        "yes": "Yes",
        "wood": "Wood",
        "other": "Other",
        "catalog_no": "Catalog No.",
        "view": "View",
        "notAvailable": "Not Available",
        "private_notes": "Private Notes"
    },
    "de": {}
};